export class Aisle {
  id = 0;
  name = "";
  isActive = true;
  stockId = 0;
  updatedAt: string;
}